import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import { AppLayout } from './components/AppLayout';
import {
  CirclePage,
  DmChatPage,
  DmPage,
  GroupChatPage,
  GroupsPage,
  HomePage,
  InvitesPage,
  LoginPage,
  UnlockPage,
  ProfilePage,
  RegisterPage,
  SettingsPage,
  TimelinePage
} from './pages';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/unlock',
    element: <UnlockPage />
  },
  {
    path: '/circles',
    element: <CirclePage />
  },
  {
    path: '/invites',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <InvitesPage />
      }
    ]
  },
  {
    path: '/settings',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <SettingsPage />
      }
    ]
  },
  {
    path: '/:circleId',
    element: <AppLayout />,
    children: [
      {
        path: 'timeline',
        element: <TimelinePage />
      },
      {
        path: 'profile/:username',
        element: <ProfilePage />
      },
      {
        path: 'dm',
        element: <DmPage />
      },
      {
        path: 'dm/:dmId',
        element: <DmChatPage />
      },
      {
        path: 'groups',
        element: <GroupsPage />
      },
      {
        path: 'groups/:groupId',
        element: <GroupChatPage />
      }
    ]
  }
]);

function App() {
  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
